import { MuiButton } from './button';
import { MuiPaper } from './paper';
import { MuiSelect } from './select';
import { MuiInputLabel } from './inputLabel';
import { MuiFormControl } from './formControl';
import { MuiTooltip } from './tooltip';
import { MuiAlert } from './alert';
import { MuiFormHelperText } from './formHelperText';
import { MuiDialog } from './dialog';
import { MuiMenu } from './menu';
import { MuiIconButton } from './iconButton';
import { MuiPagination, MuiPaginationItem } from './pagination';
import { MuiToggleButtonGroup, MuiToggleButton } from './toggleButton';
import { MuiCheckbox } from './checkbox';

export const getComponentOverrides = (palette) => ({
  MuiButton: MuiButton(palette),
  MuiPaper: MuiPaper(palette),
  MuiSelect: MuiSelect(palette),
  MuiInputLabel: MuiInputLabel(palette),
  MuiFormControl: MuiFormControl(palette),
  MuiTooltip: MuiTooltip(palette),
  MuiAlert: MuiAlert(palette),
  MuiFormHelperText: MuiFormHelperText(palette),
  MuiDialog: MuiDialog(palette),
  MuiMenu: MuiMenu(palette),
  MuiIconButton: MuiIconButton(palette),
  MuiPagination: MuiPagination(palette),
  MuiPaginationItem: MuiPaginationItem(palette),
  MuiToggleButtonGroup: MuiToggleButtonGroup(palette),
  MuiToggleButton: MuiToggleButton(palette),
  MuiCheckbox: MuiCheckbox(palette),
});
